import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, ImagePlus, Link2, Loader2, Package, Trash2 } from "lucide-react";
import { fileToPhoto } from "../../lib/image";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export const ProductImagePicker = ({ value, onChange }) => {
  const fileRef = useRef(null);
  const camRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [showUrl, setShowUrl] = useState(false);
  const [broken, setBroken] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onChange(await fileToPhoto(file));
      setBroken(false);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4" data-testid="product-image-picker">
      <div className="h-28 w-28 shrink-0 rounded-xl border bg-muted/50 grid place-items-center overflow-hidden">
        {busy ? <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /> : value && !broken ? (
          <img src={value} alt="Gambar produk" className="h-full w-full object-cover" onError={() => setBroken(true)} data-testid="product-image-preview" />
        ) : <Package className="h-8 w-8 text-muted-foreground" />}
      </div>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex flex-wrap gap-2">
          <Button type="button" variant="outline" size="sm" onClick={() => fileRef.current?.click()} disabled={busy} data-testid="product-image-upload-btn">
            <ImagePlus className="h-4 w-4 mr-2" />{value ? "Ganti Gambar" : "Unggah Gambar"}
          </Button>
          <Button type="button" variant="outline" size="sm" onClick={() => camRef.current?.click()} disabled={busy} data-testid="product-image-camera-btn">
            <Camera className="h-4 w-4 mr-2" />Ambil Foto
          </Button>
          <Button type="button" variant="ghost" size="sm" onClick={() => setShowUrl((s) => !s)} data-testid="product-image-url-toggle"><Link2 className="h-4 w-4 mr-2" />Pakai URL</Button>
          {value && <Button type="button" variant="ghost" size="sm" onClick={() => { setBroken(false); onChange(""); }} data-testid="product-image-remove-btn"><Trash2 className="h-4 w-4 mr-2" />Hapus</Button>}
        </div>
        {showUrl && (
          <Input value={value?.startsWith("data:") ? "" : value} onChange={(e) => { setBroken(false); onChange(e.target.value.trim()); }} placeholder="https://..." data-testid="product-image-input" />
        )}
        {broken && value && <p className="text-xs text-destructive" data-testid="product-image-error">Gambar dari URL tidak dapat dimuat. Periksa alamatnya atau unggah file gambar.</p>}
        <p className="text-xs text-muted-foreground">JPG/PNG/WEBP, otomatis diperkecil agar ringan dan tetap tampil saat offline.</p>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={onFile} data-testid="product-image-file-input" />
        <input ref={camRef} type="file" accept="image/*" capture="environment" hidden onChange={onFile} data-testid="product-image-camera-input" />
      </div>
    </div>
  );
};
